import React, { useState, useRef, useImperativeHandle } from 'react'
import Colors from 'Theme/Colors'
import { useTranslation } from 'react-i18next'
import { IFModal } from 'Components'
import { AdminProfile } from 'Containers'
import PropTypes from 'prop-types'

const AdminProfileModal = React.forwardRef(({ title }, ref) => {
  const { t } = useTranslation()
  const modalRef = useRef()
  const [data, setData] = useState([])
  const [roles, setRoles] = useState([])
  const customDialogContentStyle = {
    height: '600px',
    width: '1000px',
  }

  const show = (rowData, roles) => {
    if (rowData) setData(rowData)
    if (roles) setRoles(roles)
    modalRef.current.show()
  }

  const dismiss = () => {
    modalRef.current.dismiss()
  }

  useImperativeHandle(ref, () => ({
    show,
    dismiss,
  }))

  return (
    <IFModal
      title={t('AdminProfile.ModalTitle')}
      ref={modalRef}
      maxWidth={60}
      dialogContentStyle={customDialogContentStyle}
    >
      <AdminProfile
        rowData={data ? data : undefined}
        roles={roles ? roles : undefined}
      />
    </IFModal>
  )
})

AdminProfileModal.propTypes = {
  title: PropTypes.string,
  isEdit: PropTypes.bool,
}

export default AdminProfileModal
